<template>
  <div class="pi-justify-center">
    <div class="full-container" style="padding-top: 50px;max-width:1440px">
      <div class="timeline-vertical-line" style="height: 30px"></div>

      <div class="timeline-list">
        <div
          class="timeline-item"
          :class="index % 2 == 0 ? 'timeline-left' : ''"
          v-for="(item, index) in timelineList"
          :style="
            index !== 0
              ? index % 2 != 0
                ? 'margin-top:-60px'
                : 'margin-top:-80px'
              : ''
          "
          :key="'timeline' + index"
        >
          <div
            class="timeline-text-container"
            :class="index % 2 == 0 ? 'timeline-text-left' : ''"
          >
            <div class="year-container">
              <div class="red-empty-dot">
                <div class="red-dot"></div>
              </div>
              <div class="timeline-line"></div>
              <div class="timeline-year pi-fw-900">{{ item.year }}</div>
            </div>
            <div class="event-container">
              <span
                v-for="(eItem, eIndex) in item.events"
                :key="'eItem' + eIndex"
                class="pi-fz-14"
                >{{ eItem }}</span
              >
            </div>
          </div>
          <div class="img-container">
            <el-image
              v-for="(img, imgIndex) in item.img"
              :key="'img' + imgIndex"
              :src="img"
              fit="scale-down"
            ></el-image>
          </div>
        </div>
      </div>

      <div class="timeline-bottom">
        <span v-show="showAll">没有更多了</span>
        <span class="show-more" v-show="!showAll" @click="loadAll">更多+</span>
      </div>
    </div>
  </div>
</template>

<script>
import timeline from "./apj-timeline.js";
export default {
  name: "product",
  data() {
    return {
      allTimeline: false,
      loadedCount: 6,
      showAll: false,
      timelineList: [],
    };
  },
  created() {
    // this.timelineList = timeline.timelineList
    // window.addEventListener('scroll', this.handlerScroll, true)
    this.timelineList = timeline.timelineList.slice(
      0,
      parseInt(timeline.timelineList.length / 2)
    );
  },
  methods: {
    handlerScroll() {
      // let that = this
      // let all = timeline.length
      // let totalPages = Number(all / 6)
      // let currentPage = Number(this.loadedCount / 6)
      // if (window.pageYOffset > 1000 * currentPage) {
      //   let tmpCount = this.loadedCount + 6
      //   if (tmpCount > all) {
      //     tmpCount = all
      //   }
      //   this.timelineList = timeline
      //   debugger;
      // }
      // console.log('滚动高度', window.pageYOffset)
    },
    loadAll() {
      this.showAll = true;
      this.timelineList = timeline.timelineList;
    },
  },
  destroyed() {
    globalEvent.$off("loadMore");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}

$DOT_BORDER_WIDTH: 20px;
$DOT_WIDTH: 12px;

/** page style */
.empty-dot {
  width: $DOT_BORDER_WIDTH;
  height: $DOT_BORDER_WIDTH;
  border-radius: $DOT_BORDER_WIDTH;
  border: 1px solid #eeeeee;
}

.red-empty-dot {
  padding: 3px;
  width: $DOT_BORDER_WIDTH;
  height: $DOT_BORDER_WIDTH;
  border-radius: $DOT_BORDER_WIDTH;
  border: 1px solid $color-border-primary;

  .red-dot {
    width: $DOT_WIDTH;
    height: $DOT_WIDTH;
    border-radius: $DOT_WIDTH;
    background-color: $color-bg-primary;
  }
}

.timeline-vertical-line {
  margin-left: 1px;
  width: 1px;
  height: 100px;
  border-right: 1px solid #eeeeee;
}

.overview-introduce {
  height: 500px;
  align-self: flex-start;
  background-image: url("~@/assets/site/aboutus_bg2.jpg");
}
.introduce-container {
  max-width: 1140px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.timeline-list {
  padding: 0 160px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  // transition: 2s;

  .timeline-item {
    width: 50%;
    // margin-right: 13px;
    padding-bottom: 50px;
    display: flex;
    // flex-direction: column;
    border-left: 1px solid #bfbfbf;

    .timeline-text-container {
      min-width: 400px;

      .year-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        text-align: right;
        margin-left: -11px;

        .timeline-line {
          border-top: 1px dashed #bfbfbf;
        }
        .timeline-year {
          width: 100px;
          font-size: 24px;
          line-height: 50px;
          color: $color-text-primary;
        }
      }
      .event-container {
        padding: 0 14px;
        // margin-left: -14px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        text-align: right;
      }
    }
    .img-container {
      display: flex;
      align-items: center;
      flex-direction: row;

      .el-image {
        width: auto;
        height: 120px;
        padding: 0 5px;
      }
    }
  }

  // .timeline-item:hover {
  //   cursor: pointer;
  //   // background-color: $color-bg-grey;

  //   .year-container {
  //     .timeline-line {
  //       border-top: 1px dashed #BFBFBF;
  //     }
  //     .timeline-year {
  //       color: $color-text-primary;
  //     }
  //   }
  //   .event-container span {
  //       color: $color-text-primary;
  //   }
  // }

  .timeline-left {
    margin-left: 1px;
    align-self: flex-start;
    flex-direction: row-reverse;
    border-right: 1px solid #bfbfbf;
    border-left: unset;

    .img-container {
      flex-direction: row-reverse !important;
    }
  }

  .timeline-text-left {
    margin-left: 1px;
    flex-direction: row-reverse;
    align-self: flex-start;
    border-left: unset;
    text-align: left !important;

    .year-container {
      margin-left: 10px !important;
      flex-direction: row-reverse !important;
      justify-content: flex-start !important;
      text-align: left !important;
    }
    .event-container {
      // margin-left: 13px !important;
      align-items: flex-start !important;
      text-align: left !important;
    }
  }
}

.timeline-bottom {
  padding: 20px 0 50px;

  span,
  i {
    color: $color-text-grey;
  }
}

.show-more:hover {
  cursor: pointer;
}

@media screen and (max-width: 1279px) {
  .timeline-list {
    padding: 0 80px;
    .timeline-item {
      .timeline-text-container {
        min-width: 300px !important;
      }
    }
  }
}
@media screen and (max-width: 1440px) and (min-width: 1280px) {
  .timeline-list {
    padding: 0 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/history/index.vue